module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('User_ForgotPassword', {

		configure: function(options) {
			options.formElement = '#forgot_form';
			options.dataLayer || (options.dataLayer = {});
			options.dlClass = 'User_ForgotPassword';
			this.callParent('configure', arguments);
		},

		rendering: function() {
			this.addHandler('formSubmit', this.options.formElement, 'submit', fox.bind(this.submit, this));
		},

		submit: function(){
			
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/user/forgotpassword.js
// module id = 1131
// module chunks = 4